import { cn } from "../../lib/utils.js";

/**
 * Ponto vermelho indicando items pendentes.
 * O container pai deve ter `position: relative`.
 *
 * @param {{ count?: number, className?: string }} props
 */
export function PendingBadge({ count = 0, className }) {
  if (!count || count <= 0) {
    return null;
  }

  const label =
    count === 1
      ? "1 item pendente de aprovação"
      : `${count} items pendentes de aprovação`;

  return (
    <span
      className={cn(
        "absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full bg-red-500",
        className,
      )}
      title={label}
      aria-label={label}
    />
  );
}
